import { useSelector } from 'react-redux';
import {
    foremanSelector,
    managersSelector,
    purchaseSelector,
} from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useProjectTeamRow = () => {
    const managers = useSelector(managersSelector.selectAll);
    const foremans = useSelector(foremanSelector.selectAll);
    const purchases = useSelector(purchaseSelector.selectAll);
    //@ts-ignore
    const { is_customer, can_show_financial_info } = useSelector((state) => state.dashboardReducer);
    const project_users = {
        manager: managers,
        foreman: foremans,
        purchaser: purchases,
    };
    return { project_users, is_customer, can_show_financial_info };
};
